import React, {memo, useState, useEffect, useContext} from "../../../__snowpack__/pkg/react.js";
import LocaleContext from "../../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {Col, Form, Row} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {Modal} from "../../../__snowpack__/pkg/antd.js";
const i18n = {
  "zh-cn": {
    search: `\u641C\u7D22`,
    confirm: `\u786E\u8BA4`
  },
  en: {
    search: `Search`,
    confirm: `Confirm`
  },
  id: {
    confirm: `Confirm`,
    search: `Cari`
  },
  vi: {
    confirm: `X\xE1c nh\u1EADn`,
    search: `T\xECm ki\u1EBFm`
  },
  th: {
    confirm: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19`,
    search: `\u0E04\u0E49\u0E19\u0E2B\u0E32`
  }
};
const precisionItem = ["ORDER_ID", "SKU", "INVENTORY_SKU"];
export const TableFormModal = memo((props) => {
  const {
    isModalVisible,
    onSubmit,
    onCancel,
    formItemHandler,
    initialValues,
    title,
    colSpan,
    okText,
    width,
    otherFormItem
  } = props;
  const [form] = Form.useForm();
  const {locale} = useContext(LocaleContext);
  const [_, forceUpdate] = useState([]);
  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, {
    width: !!formItemHandler(form).props.children.length ? width ? width : 1e3 : 500,
    title,
    visible: isModalVisible,
    bodyStyle: {padding: "14px 24px"},
    okText: okText || i18n[locale].confirm,
    onOk: () => form.validateFields().then((values) => {
      onSubmit(values);
    }).catch((errorInfo) => {
    }),
    onCancel
  }, /* @__PURE__ */ React.createElement(FormWrapper, null, /* @__PURE__ */ React.createElement(Form, {
    form,
    layout: "vertical",
    onValuesChange: (changedValues, allValues) => {
      forceUpdate([]);
    },
    initialValues
  }, !!formItemHandler(form).props.children.length ? /* @__PURE__ */ React.createElement(Row, {
    gutter: 16
  }, formItemHandler(form).props.children.filter((item) => React.isValidElement(item)).map((item, index) => {
    return /* @__PURE__ */ React.createElement(Col, {
      className: "gutter-row",
      span: colSpan ? colSpan : 24,
      key: index
    }, item);
  }), otherFormItem && form && otherFormItem(form) ? otherFormItem(form)?.filter((item) => React.isValidElement(item))?.map((item, index) => {
    if (item) {
      return /* @__PURE__ */ React.createElement(Col, {
        className: "gutter-row",
        span: colSpan ? colSpan : 24,
        key: index
      }, item);
    }
  }) : null) : /* @__PURE__ */ React.createElement(Row, {
    gutter: 16
  }, /* @__PURE__ */ React.createElement(Col, {
    className: "gutter-row",
    span: 24
  }, formItemHandler(form))))));
});
const FormWrapper = styled.div`
  .ant-select-selection__choice__content {
    .select-checkbox {
      display: none !important;
    }
  }
  .select-checkbox {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }
  .ant-input-number-handler-wrap {
    display: none;
  }
  .ant-input-group.ant-input-group-compact {
    display: flex;
    width: 100%;
    & > .ant-input-number {
      flex: 1;
    }
  }
  .ant-input-group.ant-input-group-compact > :not(:last-child):focus {
    margin-right: 1px;
    border-right-width: 1px;
  }
  .site-input-right:focus {
    border-left: 1px solid #834aff !important;
  }
  .site-input-left:focus {
    border-right: 1px solid #834aff !important;
  }

  .ant-select-selection-overflow {
    display: flex;
    flex-wrap: wrap;
    & > .ant-select-selection-overflow-item:first-child {
      max-width: 200px;
    }
  }
  .ant-select-selection-overflow-item-suffix {
    .ant-select-selection-search {
      height: 100%;
      .ant-select-selection-search-input {
        height: inherit;
      }
    }
  }
`;
